import { createAttachment, updateAttachmentFile } from 'common/api/attachments';
import showToast from 'common/utils/showToast';

import filterAttachments from '../../attachments/actions/filterAttachments';
import * as attachmentsSelectors from '../../attachments/selectors';
import { SAVE, SAVE_SUCCESS, SAVE_FAILURE } from '../actionTypes';
import { createAttachmentModalActions } from '../reducer';

import closeModal from './closeModal';

export default (values) => (dispatch, getState) => {
    const filterData = attachmentsSelectors.getFilterData(getState());
    dispatch(createAttachmentModalActions[SAVE]());

    const newValues = {
        name: values.name,
        system: values.system,
        file: values.attachment_file,
    };

    const action = values.id
        ? updateAttachmentFile(newValues, values.id)
        : createAttachment(newValues);

    action
        .then((response) => {
            dispatch(createAttachmentModalActions[SAVE_SUCCESS](response.data));
            if (filterData) dispatch(filterAttachments(filterData));
            dispatch(closeModal(false));
            showToast();
        })
        .catch((error) =>
            dispatch(
                createAttachmentModalActions[SAVE_FAILURE](
                    error?.response?.data?.errors,
                ),
            ),
        );
};
